module.exports = __webpack_public_path__ + "img/homeoffice.0b70789c.png";